import {
  TENANT_AT,
  TENANT_BE,
  TENANT_CH,
  TENANT_COM,
  TENANT_FR,
  TENANT_IT,
} from 'shared/consts'

import type { TenantBasedExperiment } from './types'

export const CARTINTERMEDIATE_ERX_BANNER: TenantBasedExperiment = {
  [TENANT_COM]: { desktop: 'cro-2940', mobile: 'cro-2941' },
}

export const EXIT_INTENT_POPUP_EXPERIMENT: TenantBasedExperiment = {
  [TENANT_COM]: { desktop: 'cro-3102', mobile: 'cro-3103' },
  [TENANT_AT]: { desktop: 'cro-3105', mobile: 'cro-3104' },
  [TENANT_FR]: { desktop: 'cro-3109', mobile: 'cro-3108' },
  [TENANT_IT]: { desktop: 'cro-3106', mobile: 'cro-3107' },
  [TENANT_CH]: { desktop: 'cro-3110', mobile: 'cro-3111' },
}

export const CHANGE_CTA_TEXT_NAME_BE: TenantBasedExperiment = {
  [TENANT_BE]: 'cro-3358',
}

export const NEWSLETTER_MODAL: TenantBasedExperiment = {
  [TENANT_CH]: {
    desktop: 'cro-4137',
    mobile: 'cro-4137',
  },
  [TENANT_IT]: {
    desktop: 'cro-5952',
    mobile: 'cro-5952',
  },
  [TENANT_FR]: {
    desktop: 'cro-4655',
    mobile: 'cro-4655',
  },
  [TENANT_AT]: {
    desktop: 'itrt-880',
    mobile: 'itrt-880',
  },
}

export const HEADER_STICKY_TOGGLE_EXPERIMENT: TenantBasedExperiment = {
  [TENANT_COM]: 'cro-4789',
  [TENANT_AT]: 'cro-4790',
  [TENANT_IT]: 'cro-4791',
  [TENANT_FR]: 'cro-4792',
  [TENANT_CH]: 'cro-4794',
  [TENANT_BE]: 'cro-4793',
}
